"use client";

import type { RefObject } from "react";
import type { Swiper as SwiperType } from "swiper";

import { CarouselCenteredNavButton } from "@/components/carouselCentered/carouselCenteredNavButton.component";
import { CarouselCenteredProgress } from "@/components/carouselCentered/carouselCenteredProgress.component";

export const SuggestedForYouControls = ({
  swiperRef,
  activeIndex,
  totalSlides,
}: SuggestedForYouControlsProps) => {
  if (totalSlides <= 1) return null;

  return (
    <>
      <div className="mt-6 hidden justify-center lg:flex">
        <CarouselCenteredProgress
          activeIndex={activeIndex}
          totalSlides={totalSlides}
        />
      </div>
      <div className="mt-6 flex items-center justify-center gap-4 lg:hidden">
        <CarouselCenteredNavButton swiperRef={swiperRef} direction="prev" />
        <CarouselCenteredProgress
          activeIndex={activeIndex}
          totalSlides={totalSlides}
        />
        <CarouselCenteredNavButton swiperRef={swiperRef} direction="next" />
      </div>
    </>
  );
};

export type SuggestedForYouControlsProps = {
  swiperRef: RefObject<SwiperType | null>;
  activeIndex: number;
  totalSlides: number;
};
